module.exports = __webpack_public_path__ + "img/f5-1.88d33e3f.jpg";